import React from 'react';
import PropTypes from 'prop-types';
import TableUtils from '../../../../../../../utils/TableUtils';
import UiUtils from '../../../../../../../utils/UiUtils';
import { FF_HISTORIAL_LABORAL } from "../../../../../../../config";
import ApiClient from '../../../../../../../utils/ApiClient';
import PermissionChecker from '../../../../../../../components/permission-checker/PermissionChecker';
import QuestionDialog from '../../../../../../../components/question-dialog/QuestionDialog';
import StrongText from '../../../../../../../components/strong-text/StrongText';
import {
	BootstrapTable,
	TableHeaderColumn
} from 'react-bootstrap-table';
import {
	Row,
	Col,
	Button,
	Table,
	OverlayTrigger,
	Popover,
} from 'react-bootstrap';
import lstrings from '../../../../../../../utils/LStrings';
import 'react-bootstrap-table/css/react-bootstrap-table.css';
import Session from "../../../../../../../utils/Session";

class TableRelacionDependencia extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			data: this.processData(props.data.datos),
			showQuestionDialogHistoriaPrevisional: false,
			showConfirmHistoriaPrevisional: false,
			ffHistorialLaboral: false,
		};
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			data: this.processData(nextProps.data.datos)
		});
	}


	componentDidMount() {
		ApiClient.getFeatureFlag(FF_HISTORIAL_LABORAL).then((res) => {
			this.setState({
				ffHistorialLaboral: res.results[FF_HISTORIAL_LABORAL],
			})
		})
		// TODO: revisar qué pasa si el servicio devuelve error (no queremos que se cierre la sesión con error inesperado)
	}


	processData = (data) => {
		if (data != null) {
			return data.map((item, ix) => {
				return {
					ix: ix,
					id: item.relacionDependencia.id,
					alta: item.relacionDependencia.alta,
					cuit: item.relacionDependencia.cuit,
					estado: item.relacionDependencia.estado,
					razonSocial: item.relacionDependencia.razonSocial,
					sueldo: item.relacionDependencia.sueldo,
					baja: item.relacionDependencia.baja,
					historialSueldo: item.historialSueldo
				};
			});
		}
		return null;

	}

	gridOptions = () => {
		return TableUtils.defaultConfig();
	}

	expandedRow = (row) => {
		return (
			<div width='75%'>
				<h2>General</h2>
				<Table striped bordered condensed fill responsive>
					<thead>
						<tr>
							<td width='75%' key={0}>
								Actividad Empleador
							</td>
							<td width='25%' key={1}>
								Cant. Empleados
							</td>
						</tr>
					</thead>
					<tbody>
						<tr key={0}>
							<td>
								{TableUtils.stringFormat(
									row.historialSueldo.infoAdicionalEmpleador.actividadempleador)}
							</td>
							<td>
								{TableUtils.formatearNumeroEntero(
									row.historialSueldo.infoAdicionalEmpleador.cantidadempleados)}
							</td>
						</tr>
					</tbody>
				</Table>
			</div>
		);
	}

	periodoFormatter = (value, row) => {
		return `${TableUtils.dateFormat(row.alta)} - ${TableUtils.dateFormat(row.baja)}`;
	}

	/**
	 * Muestro el primer diálogo de Solicitud de Historia Previsional
	 */
	onSolicitarHistorialPrevisionalClick = () => {
		this.setState({
			showQuestionDialogHistoriaPrevisional: true,
		})
	}

	/**
	 * Muestro el segundo diálogo de Solicitud de Historia Previsional
	 */
	onSolicitarHistorialPrevisionalAccept = () => {
		this.setState({
			showConfirmHistoriaPrevisional: true,
		})
	}

	/**
	 * Ejecuto la acción de Solicitud de Historia Previsional
	 */
	onConfirmHistorialPrevisionalAccept = () => {
		UiUtils.showProgress(true)
		ApiClient.solicitarInformePrevisional(this.props.cuil)
			.then(this.onFinishSolicitarHistorialPrevisional)
			.catch((error) => {
				UiUtils.showError(error);
				this.closeDialogsHistorialPrevisional();
			})

		console.log(`mandando solicitud para cuil ${this.props.cuil}`)
		UiUtils.showProgress(false);
		this.closeDialogsHistorialPrevisional();
	}

	/**
	 *
	 */
	onFinishSolicitarHistorialPrevisional = (res) => {
		console.log("resultado", res)

		if (res.result.code === 200) {
			if (!res.data) {
				throw UiUtils.handledError("Ocurrió un error al enviar la Solicitud de Historial Previsional");
			}
		} else {
			throw UiUtils.handledError(res.result.info);
		}
	}

	/**
	 * Cierro todos los diálogos de confirmación de solicitud
	 */
	closeDialogsHistorialPrevisional = () => {
		this.setState({
			showQuestionDialogHistoriaPrevisional: false,
			showConfirmHistoriaPrevisional: false,
		})
	}

	render() {
		return (
			<PermissionChecker
				infoKey='datoLaboral'
				infoTitle=''
				data={this.props.data}
				onRequestInfo={this.props.onRequestInfo}
				hidePanels={this.props.hidePanels}
			>
				<BootstrapTable data={this.state.data}

					expandableRow={() => true}
					expandComponent={this.expandedRow}
					options={this.gridOptions()}>
					<TableHeaderColumn
						dataField="ix"
						isKey
						width='30'
						dataFormat={TableUtils.plusButtonFormat}>&nbsp;
					</TableHeaderColumn>
					<TableHeaderColumn
						dataField="estado"
						dataFormat={TableUtils.colorearEstadoLaboral}
						width='70' >{lstrings.estado}
					</TableHeaderColumn>
					<TableHeaderColumn
						dataField="cuit"
						width='140'
						dataFormat={TableUtils.cuitFormat}>{lstrings.cuit}
					</TableHeaderColumn>
					<TableHeaderColumn
						dataField="razonSocial">{lstrings.razonsocial}
					</TableHeaderColumn>
					<TableHeaderColumn
						dataField="alta"
						width='300'
						dataFormat={this.periodoFormatter}>{lstrings.periodoUltimo}
					</TableHeaderColumn>
					{!Session.getUser().isDisa && this.props.rangoIngresos &&
						<TableHeaderColumn
							dataField="sueldo"
							dataFormat={(cell) => <OverlayTrigger
								trigger={["hover", "focus"]}
								placement="top"
								overlay={
									<Popover>
										<span>
											{this.props.rangoIngresos[cell]}
										</span>
									</Popover>
								}>
								<span>{cell}</span>
							</OverlayTrigger>}
							width='200'
							tdStyle={{
								cursor: 'help'
							}}>
							{lstrings.nivelIngreso}
						</TableHeaderColumn>
					}
				</BootstrapTable>
				<br />
				{this.state.ffHistorialLaboral && <div>
					<Row>
						<Col sm={4} smOffset={4}>
							<Button
								bsStyle="primary"
								className="btn-block"
								onClick={this.onSolicitarHistorialPrevisionalClick}
							>
								{lstrings.historialPrevisional_solicitud}
							</Button>
						</Col>
					</Row>
					<QuestionDialog
						show={this.state.showQuestionDialogHistoriaPrevisional}
						onAccept={this.onSolicitarHistorialPrevisionalAccept}
						onCancel={this.closeDialogsHistorialPrevisional}
						title={<b>{lstrings.historialPrevisional_solicitud}</b>}
						message={<div>
							<p>
								<StrongText
									text="La solicitud del Informe Previsional implica costos adicionales." />
							</p>
							<p>
								¿Está seguro usted de generar esta solicitud?
							</p>
							<p>
								Al aceptar, su ejecutivo de cuenta se pondrá en contacto
								para hacerle llegar los costos por la información.
							</p>
						</div>}
					/>
					<QuestionDialog
						show={this.state.showConfirmHistoriaPrevisional}
						onAccept={this.onConfirmHistorialPrevisionalAccept}
						onCancel={this.closeDialogsHistorialPrevisional}
						title={<b>{lstrings.historialPrevisional_solicitud}</b>}
						message="Por favor, confirme la acción"
						acceptText="Confirmar"
					/>
				</div>
				}
			</PermissionChecker>
		);
	}

}

TableRelacionDependencia.propTypes = {
	cuil: PropTypes.string,
	data: PropTypes.any,
	onRequestInfo: PropTypes.func,
	hidePanels: PropTypes.any,
	rangoIngresos: PropTypes.object
}

export default TableRelacionDependencia;



// WEBPACK FOOTER //
// ./src/scenes/personas/components/personas-detalle/components/panel-datos-laborales/components/TableRelacionDependencia.js